<template>
    <div :class="{'activity-detail': true, 'mask': payTypeVisible}">
        <div class="content" v-if="detail">
            <h1 class="title" v-text="detail.title"></h1>
            <p class="create-time">
                <span class="hint">活動時間：</span>
                <span v-text="detail.starttime"></span>
                <span> 至 </span>
                <span v-text="detail.endtime"></span>
             </p> 
            <p class="start-notice" v-if="noticeTitle" v-text="noticeTitle ? noticeTitle : ''"></p>
            <p class="address">
                <span class="hint">活動地點：</span>
                <span v-text="detail.address"></span>
                <a :href="`https://www.google.com.hk/maps/search/?api=1&query=${detail.lat},${detail.lng}`" target="_blank">查看地图</a>
            </p>
            <p class="sale" v-if="detail.isfeeunsure == true"><span class="hint">報名費用：</span>活動詳情為准</p>
            <p class="sale" v-if="detail.isfree == true"><span class="hint">報名費用：</span>活動詳情為准</p>
            <div v-if="detail.isfeeunsure != true && detail.isfree != true">
                <p class="sale">
                    <span class="hint">非本會會員報名費用：</span>
                    <span v-text="`${detail.entryfee.toFixed(2)} HK$`"></span>
                </p>
                <p class="sale">
                    <span class="hint">本會會員報名費用：</span>
                    <span v-text="`${detail.entryfee2.toFixed(2)} HK$`"></span>
                </p>
                <p class="sale">
                    <span class="hint">支付方式：</span>
                    <span v-for="(payType, i) in detail.paymethodList" :key="i" v-text="`${payType.paymethodname}；`"></span>
                </p>
            </div>
            <p class="sale" v-if="detail.hasregcount">
                <span class="hint">報名人數：</span>
                <span v-text="detail.hasregcount"></span>
            </p>
            <div class="intro">
                <span class="hint">摘要：</span>
                <span v-text="detail.introduce"></span>
            </div>
            <div class="content-wrapper" v-html="detail.content" @click="onContentClick">
            </div>
            <div v-for="(file, index) in files" :key="index" style="display: flex; flex-direction: column;margin-bottom: 24px;">
                <h2 v-text="`${file.title}:`" style="font-size: 28px;font-weight: bold; color: #232323;"></h2>
                <!-- <canvas ref="myCanvas"></canvas> -->
                <object :data="file.path" :type="`application/${file.fileType}`" width="100%" style="height: 1080px"></object>
            </div>
            <div @click="onContentClick2">
                <div v-for="(file,index) in imgFiles" :alt="file.title" :key="index" style="display: flex; flex-direction: column;margin-bottom: 24px;">
                    <h2 v-text="`${file.title}:`" style="font-size: 28px;font-weight: bold; color: #232323;"></h2>
                    <img :src="file.path" :alt="file.title">
                </div>
                <viewer :options="{toolbar: false, navbar: false}" @inited="inited2" :images="images2" ref="viewer2" style="display: none;">
                    <img v-for="(file,index) in imgFiles" :src="file.path" :alt="file.title" :key="index">
                </viewer>
            </div>
            <!-- 包名活动 start -->
            <div class="btn-wrapper" v-if="detail.showapply">
                <a-button type="primary" size="large" block :disabled="detail.isRegActivity == true || isFinished" @click="onJoinModalShow" v-text="buttonText"></a-button>
            </div>
            <div class="link-activity" v-if="detail.isRegActivity">
                <router-link to="/user/myActivity">查看全部報名過的學會課程</router-link>
            </div>
            <!-- 包名活动 end -->
            <viewer :options="{toolbar: false, navbar: false}" @inited="inited" :images="images" ref="viewer" style="display: none;">
                <img v-for="src in images" :src="src" :key="src">
            </viewer>
            <!-- 报名活动信息填写 start -->
            <a-modal
                title="課程活動報名"
                :width="modalWidth"
                height="600"
                style="z-index: 10000"
                :visible="visible"
                :confirm-loading="confirmLoading"
                @ok="handleOk"
                @cancel="handleCancel"
                okText="確認"
                cancelText="取消"
                :maskClosable="false"
            >
            <div class="viewer-info">
                <p class="act-title">
                    <span class="hint">學會活動名稱:</span>
                    {{detail.title || '--'}}
                </p>
                <p class="act-time">
                    <span class="hint">學會活動時間: </span>
                    <span v-text="detail.starttime || '--'"></span>
                    <span> 至 </span>
                    <span v-text="detail.endtime || '--'"></span>
                </p>
                <p class="act-address">
                    <span class="hint">學會活動地點: </span>
                    <span v-text="detail.address || '--'"></span>
                </p>
            </div>
                <!-- 課程報名及付款的需要資料
                （*為必需資料）
                1.* 姓名 中文/英文
                2.註冊編號
                3.會員編號 （新增會員時由行政機構賦予，將來有機會根據情況改動，可以因為是非會員而空缺）
                4.* 聯絡電話
                5.行政機構成員編號 （三個組成部份 CME-ADM009-AA0495 1. CME 2. ADM009 根據行政機構名單 3. 醫師編號 由行政機構賦予）
                6.* 參加項目編號
                7.* 金額 （可設定提早報名有不同折扣，以報名時段區分，例如30天前減免50，14天前減免20，或是折扣）
                8.* 參加者類別 （醫師/非醫師/會員-醫師資格/會員-非醫師資格）
                9.* 支付方式 （現金/支票/支付寶/微信 可只提供一種或多種）
                10.收㨿編號 （自動生成）
                11.備註 （管理職員按所需填入資料）
                12.存款單號碼 （管理員日後進行收款成功後按所需的填入編號備註）
                13.* 學分 （管理職員按所需可填入低於原設定的學分）
                14.補證書行政費
                15.巳取/未取證書備註
                16.答題合格/不合格備註
                17.個人地址
                18.簽到/未簽到備註 -->
                <a-form-model 
                    :model="form"
                    ref="ruleForm"
                    :label-col="labelCol"
                    :rules="rules"
                    :wrapper-col="wrapperCol"
                >
                    <a-form-model-item label="姓名" prop="regUserName">
                        <a-input disabled v-model="form.regUserName" />
                    </a-form-model-item>
                    <a-form-model-item label="註冊編號">
                        <a-input disabled v-model="form.regCode" />
                    </a-form-model-item>
                    <a-form-model-item label="會員編號">
                        <a-input disabled v-model="form.memberCode" />
                    </a-form-model-item>
                    <a-form-model-item label="聯絡電話" prop="mobile">
                        <a-input disabled placeholder="請輸入 (8位或者13位的手机号)" v-model="form.mobile" />
                    </a-form-model-item>
                    <a-form-model-item label="參加者類別" prop="regUserType">
                        <a-select v-model="form.regUserType" placeholder="請選擇" disabled>
                            <!-- 醫師/非醫師/會員-醫師資格/會員-非醫師資格 -->
                            <a-select-option value="1">非學會會員（醫師）</a-select-option>
                            <a-select-option value="4">非學會會員（非醫師）</a-select-option>
                            <a-select-option value="2">學會會員（醫師）</a-select-option>
                            <a-select-option value="8">學會會員（非醫師）</a-select-option>
                        </a-select>
                    </a-form-model-item>
                    <!-- <a-form-model-item label="個人地址">
                        <a-cascader
                            class="item-address"
                            :options="options"
                            :fieldNames="{ label: 'codedesc', value: 'codeid', children: 'children' }"
                            :load-data="loadData"
                            placeholder="請選擇"
                            change-on-select
                            :loading="true"
                            v-model="areas"
                            @change="onChange"
                        />
                        <a-input disabled v-if="areas && areas.length===2" v-model="form.address" placeholder="請輸入詳細地址"/>
                    </a-form-model-item> -->
                    <a-form-model-item label="金額">
                        <a-input disabled v-model="jine" @change="jine = `學會會員: ${detail.entryfee2.toFixed(2)}HK$, 非學會會員: ${detail.entryfee.toFixed(2)}HK$`"/>
                    </a-form-model-item>
                    <a-form-model-item v-if="showPay" label="支付方式" prop="paymentWay">
                        <!-- 現金/支票/支付寶/微信 可只提供一種或多種 -->
                        <a-radio-group v-model="form.paymentWay" class="pay-list">
                            <a-radio :value="type.value" class="radio-item" v-for="(type, i) in payTypeList.filter(v=>v.visible)" :key="i">
                                <img class="icon-pay" :src="type.asset"/>
                                <span class="txt-pay" v-text="type.title"></span>
                            </a-radio>
                        </a-radio-group>
                    </a-form-model-item>
                    <a-form-model-item label="備註">
                        <!-- 備註 （管理職員按所需填入資料） -->
                        <a-textarea v-model="form.remark" />
                    </a-form-model-item>
                </a-form-model>
            </a-modal>
            <!-- 报名活动信息填写 end -->
            <a :href="payUrl" style="display: none;" id="payLink"></a>
            <div class="pay-type" v-if="payTypeVisible">
                <div class="close" @click="cancelChoosePayType">X</div>
                <div class="pay-type-head">請選擇支付方式</div>
                <a-radio-group class="radio-group" v-model="repayForm.paymentWay">
                    <a-radio :value="type.value" class="radio-item" v-for="(type, i) in payTypeList.filter(v=>v.visible)" :key="i">
                        <img class="icon-pay" :src="type.asset"/>
                        <span class="txt-pay" v-text="type.title"></span>
                    </a-radio>
                </a-radio-group>
                <a-button type="primary" size="large" block @click="confirmChoosePayType">去支付</a-button>
            </div>
        </div>

        <a-modal
            title="提示"
            style="z-index: 10001"
            width="350px"
            :visible="payingVisible"
            :maskClosable="false"
            @cancel="onPayModalClose"
            :footer="null"
        >
            <div style="height: 300px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                <div style="flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                    <a-spin size="large" tip="等待支付..."/>
                </div>
                <a-button type="primary" size="large" block @click="onReload">我已經支付完成</a-button>
                <span style="margin-top: 10px; font-size: 12px; color: #f00; font-weight: 400;">如果已經付款成功，可以直接刷新界面。</span>
            </div>
        </a-modal>
        <a-modal
            style="z-index: 10001"
            width="350px"
            :visible="payResultVisible"
            :maskClosable="false"
            @cancel="onReload"
            :footer="null">
                <a-result
                    :status="`${paySuccess ? 'success' : 'error'}`"
                    :title="payTitle"
                    :sub-title="subPayTitle"
                >
                    <template #extra>
                        <a-button key="console" :type="`${paySuccess == true ? 'primary' : 'danger'}`" @click="onReload">
                            知道了
                        </a-button>
                    </template>
                </a-result>
        </a-modal>
    </div>
</template>

<script>
import pdfJS from "pdfjs-dist";
import {baseUrl} from '../../common/request';
export default { 
    components: {
    },
    data(){
      return {
        payTypeList: [
            {
                asset: require('assets/imgs/ic_xianchang.png'),
                title: '現場支付',
                value: 1,
                visible: false
            },{
                asset: require('../../assets/imgs/ic_zhipiao.png'),
                title: '支票',
                value: 2,
                visible: false
            },{
                asset: require('../../assets/imgs/ic_hukou.png'),
                title: '戶口存款',
                value: 4,
                visible: false
            },{
                asset: require('../../assets/imgs/ic_xinyongka.png'),
                title: '信用卡',
                value: 8,
                visible: false
            },{
                asset: require('../../assets/imgs/ic_wechat.png'),
                title: '微信',
                value: 16,
                visible: false
            },{
                asset: require('../../assets/imgs/ic_alipay.png'),
                title: '支付寶',
                value: 32,
                visible: false
            }
        ],
        style: '',
        baseUrl,
        noticeTitle: null,
        noticeTitleTimer: null,
        modalWidth: '75%',
        timer: null,
        currentPage: 0, // pdf文件页码
        pageCount: 0, // pdf文件总页数
        fileType: 'pdf', // 文件类型
        isFinished: false,
        buttonText: '立即報名',
        payingVisible: false,
        payResultVisible: false,
        paySuccess: false,
        payTitle: '加入學會活動成功',
        subPayTitle: '',//支付结果描述
        orderNo: '',//支付订单号
        payUrl: '', //支付页面XML
        visible: false,//是否显示报名信息填写窗口
        confirmLoading: false,//报名活动加载状态
        labelCol: { span: 4 },
        wrapperCol: { span: 14 },
        options: [],
        areas: [],
        jine: '',
        reWriteInfo: null,
        userInfo: this.$store.getters.userInfo,
        showPay: true,
        repayForm: {
            paymentWay: undefined,
        },
        form: {
            activityId: undefined, //活动id
            address: undefined, //个人地址
            area1: undefined, //地区编码1
            area2: undefined, //地区编码2
            currency: 'HK', //币种 CN人民币 / HK港币, 默认HK
            memberCode: undefined, //会员编号
            mobile: undefined, //联系电话
            paymentWay: undefined, //支付方式, 16微信 / 32支付宝
            regCode: undefined, //注册编号, 注册编号长度最大为10
            regUserName: undefined, //姓名
            regUserType: undefined, //参加者类别, 1医师 / 4非医师 / 2会员-医师 / 8会员-非医师
            remark: undefined, //备注
            source: 'WEB', // 请求数据来源, APP/WEB 默认WEB
            uid: this.$store.getters.userInfo && this.$store.getters.userInfo.clientid, //用户id
        },
        files: [],
        images: [],
        images2: [],
        imgFiles: [],
        detail: JSON.parse(sessionStorage.getItem('detail')),
        rules: {
            regUserName: [{ required: true, message: '請輸入您的姓名(中文或者英文)', trigger: 'blur' }],
            mobile: [{required: true, message: '請輸入您的聯絡電話', trigger: 'blur' }, {pattern: /^(([5|6|8|9])\d{7})|(1[3-9]{1}[0-9]{9})$/, required: true, message: '輸入聯絡電話格式不正确', trigger: 'blur' }],
            paymentWay: [{ required: true, message: '請選擇支付方式', trigger: 'change' }],
            regUserType: [{ required: true, message: '請選擇參加者類別', trigger: 'change' }],
        },
        payTypeVisible: false,
      }
    },
    mounted: function(){
        if(/Android|webOS| iPhone | iPad | iPod |BlackBerry|opera mini|opera mobile|appleWebkit.*mobile|mobile/i.test(navigator.userAgent)) {
            this.modalWidth = '95%'
        }
        if(this.detail) {
            this.setPayTypeList()
            this.changeNoticeTitle();
            this.jine = `學會會員: ${this.detail.entryfee2.toFixed(2)}HK$, 非學會會員: ${this.detail.entryfee.toFixed(2)}HK$`;
            // var start = this.detail.starttime && new Date(this.detail.starttime.replace(/-/g, '/')).getTime()
            var end = this.detail.endtime && new Date(this.detail.endtime.replace(/-/g, '/')).getTime()
            var now = Date.now()
            this.buttonText = '立即報名'
            this.isFinished = false
            if(this.detail.isRegActivity == true) {
                this.isFinished = true
                this.buttonText = '已報名'
            } else if(now > end) {
                this.isFinished = true
                this.buttonText = '已結束'
            } else {
                // this.detail.regStatus = 1
                if(this.detail.regStatus == 1) {
                    this.buttonText = '待支付 (點擊完成支付) '
                } else if(this.detail.regStatus == 2) {
                    //完成报名，等待学会审核
                    this.isFinished = true
                    this.buttonText = '已報名(等待學會審核)'
                }
            }

            if(this.detail.listattach && this.detail.listattach.length) {
                var list = JSON.parse(JSON.stringify(this.detail.listattach))
                this.imgFiles = list.map((d)=>{return {
                    "title": d['t'],
                    "path": (d['p'] || '').toLowerCase()
                }}).filter((d)=>/(jpg|jpeg|png|bmp)$/.test(d.path)) || []

                this.files = list.map((d)=>{return {
                    "title": d['t'],
                    "path": (d['p'] || '').toLowerCase(),
                    "fileType": (d['p'] || '').substr((d['p'] || '').lastIndexOf('.')+1),
                }}).filter((d)=>!/(jpg|jpeg|png|bmp)$/.test(d.path)) || []
            }
        }

        // this.$store.dispatch('getAreaList', {'langcode': 'B5'})
        // .then((rs) => {
        //     this.options = (rs || []).map((d)=>{
        //         return {
        //             ...d,
        //             isLeaf: false
        //         }
        //     })

        //     var userInfo = this.$store.getters.userInfo;
        //     if(userInfo && userInfo.arealevel1id) {
        //         var option = this.options.find((d)=>d.codeid == userInfo.arealevel1id)
        //         this.$store.dispatch('getAreaList', {'langcode': 'B5', 'parentId': userInfo.arealevel1id})
        //         .then((rs) => {
        //             var children = rs || []
        //             option.children = children
        //             this.options = [...this.options]
        //         })
        //     }
        // })

        var payStatus = this.$route.query.payStatus;
        if(payStatus === 'success') {
            this.paySuccess = true;
            this.payResultVisible = true;
            this.payTitle = '加入學會活動成功';
            this.subPayTitle = '';
        } else if(payStatus === 'error') {
            this.paySuccess = false;
            this.payResultVisible = true;
            this.payTitle = '加入學會活動失败';
            this.subPayTitle = '在线支付未成功';
        }
        
    },
    methods: {
        setPayTypeList(){
            this.payTypeList.forEach((v)=>v.visible = false)
            if(this.detail && this.detail.paymethodList && this.detail.paymethodList.length) {
                this.detail.paymethodList.forEach((v)=>{
                    var item = this.payTypeList.find((d)=>d.value == v.paymethodid)
                    if(item) item.visible = true
                })
            }
            this.payTypeList = [...this.payTypeList]
        },
        choosePayType(){
            this.style = document.body.getAttribute('style') || ''
            document.body.setAttribute('style', this.style + 'overflow: hidden;')
            this.payTypeVisible = true
        },
        cancelChoosePayType(){
            this.payTypeVisible = false
            document.body.setAttribute('style', this.style)
        },
        confirmChoosePayType(){
            if(!this.repayForm.paymentWay) {
                this.$message.warning('請選擇支付方式')
                return
            }
            this.$store.dispatch('rePayActivityCost', 
            {
                'paymentWay': this.repayForm.paymentWay,
                'activityId': this.detail.activityid, 
                'clientId': this.form.uid
            })
            .then((rs) => {
                if(rs.payUrl) {
                    this.payUrl = rs.payUrl
                    this.$nextTick(()=>{
                        document.querySelector("#payLink").click()
                    })
                }
            }) 
        },
        // 初始化pdf
        init(pdfUrl) {
            pdfJS.getDocument(pdfUrl).promise.then((pdfDoc_)=> {
                this.pdfDoc = pdfDoc_;
                this.pageCount = this.pdfDoc.numPages;
                this.pageNum = 1;
                this.renderPage(this.pageNum);
            });
        },
        // 渲染pdf
        renderPage(num) {
            this.pageRendering = true;
            let canvas = this.$refs.myCanvas;
            // Using promise to fetch the page
            this.pdfDoc.getPage(num).then( (page)=> {
                var viewport = page.getViewport(this.scale);
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                let ctx = canvas.getContext("2d")
                var renderContext = {
                    canvasContext: ctx,
                    viewport: viewport,
                };
                var renderTask = page.render(renderContext);
                renderTask.promise.then( ()=> {
                    ctx.fillStyle = ctx.createPattern(
                        this.$refs.watermark,
                        "repeat"
                    );
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                    this.pageRendering = false;
                    if (this.pageNumPending !== null) {
                        this.renderPage(this.pageNumPending);
                        this.pageNumPending = null;
                    }
                });
            });
        },
        // 获取文件
        getCloudFilePreviewoss(pdfUrl) {
            return this.$axios.post(pdfUrl);
        },
        async getPreviewossUrl(pdfUrl) {
            const res = await this.getCloudFilePreviewoss(pdfUrl);
            if (res.code == 200) {
                this.getBlob(res.result);
            }
        },
        changeNoticeTitle() {
            if(this.noticeTitleTimer) {
                 clearInterval(this.noticeTitleTimer);
                 this.noticeTitleTimer = null;
            }
            if(!this.detail) return;
            this.noticeTitle = this.timeSpace(this.detail.starttime, this.detail.endtime);
            if(this.noticeTitle) {
                this.noticeTitleTimer = setTimeout(() => {
                    this.changeNoticeTitle();
                }, 60000);
            }
        },
        timeSpace(startTime, endTime) {
            if(!startTime  || !endTime) return null;
            var stime = Date.parse(new Date(startTime))
            var etime = Date.parse(new Date(endTime));
            var now = Date.now();
            var title = '';
            // 两个时间戳相差的毫秒数
            var usedTime = etime - stime;
            if(now < stime) {
                title = '距離活動開始還有：';
                usedTime = stime - now;
            } else if(now >= stime && now <= etime) {
                title = '距離活動結束還有：';
                usedTime = etime - now;
            } else {
                return null;
            }
            
            // 计算相差的天数  
            var days = Math.floor(usedTime / (24 * 3600 * 1000));
            // 计算天数后剩余的毫秒数
            var leave1 = usedTime % (24 * 3600 * 1000);  
            // 计算出小时数  
            var hours = Math.floor(leave1 / (3600 * 1000));
            // 计算小时数后剩余的毫秒数
            var leave2 = leave1 % (3600 * 1000);        
            // 计算相差分钟数
            var minutes = Math.floor(leave2 / (60 * 1000));
            var time = title + days + "天" + hours + "时" + minutes + "分";
            return time;
        },
        getBlob(result) {
            this.$axios
                .get(
                    result.previewUrl,
                    { responseType: "blob" },
                    {
                        headers: {
                            "Access-Control-Allow-Origin": "*",
                        },
                    }
                )
                .then((res) => {
                    var blob = new Blob([res], {
                        type: "application/pdf;chartset=UTF-8",
                    });
                    let fileURL= URL.createObjectURL(blob)
                    this.init(fileURL)
                })
                .catch((error) => {
                    console.log("error", error);
                });
        },
        onReload: function() {
            window.location.href = `${window.location.origin}${window.location.pathname}`
        },
        onJoinModalShow(){
            if(this.detail.isRegActivity == true || this.isFinished) return
            if(this.$store.getters.token && this.$store.getters.userInfo) {
                if(this.detail.regStatus == 1) {
                    //报名未支付，重新支付
                    this.choosePayType()
                } else if(this.detail.regStatus == 2) {
                    this.$message.warning('已報名(等待學會審核)')
                } else {
                    this.form.uid = this.$store.getters.userInfo.clientid
                    this.visible = true
                    if(!this.reWriteInfo) {
                        this.$store.dispatch('getActivityInfo', {'associationId': this.detail.associationid, 'clientId': this.form.uid})
                        .then((rs) => {
                            this.reWriteInfo = rs
                            this.reWrite()
                            // {
                            //     "clientId": 104040,
                            //     "clientNo": "CL0104040",
                            //     "clientName": "陈燕",
                            //     "clientEnName": "",
                            //     "clientMobile": "17198642416",
                            //     "clientAddress": "1详细地址00001号34",
                            //     "doctorNo": null,
                            //     "clientRegType": 7
                            // }
                        })
                    } else {
                        this.reWrite()
                    }
                }
            } else {
                this.$message.warning('未登錄，請先登錄！')
                setTimeout(() => {
                    document.querySelector("#login").click();
                }, 1500);
            }
        },
        reWrite() {
            if(!this.reWriteInfo) return
            this.showPay = true
            // 1医师 / 4非医师 / 2会员-医师 / 8会员-非医师
            if(this.detail.entryfee2 == 0 && [2,8].indexOf(this.reWriteInfo.clientRegType) != -1) {
                this.showPay = false
            } else if(this.detail.entryfee == 0 && [1,4].indexOf(this.reWriteInfo.clientRegType) != -1) {
                this.showPay = false
            }
            // `本會會員: ${this.detail.entryfee2.toFixed(2)}HK$, 非會員: ${this.detail.entryfee.toFixed(2)}HK$`;
            if(this.reWriteInfo.clientName) {
                this.form.regUserName = this.reWriteInfo.clientName;
            }

            if(this.reWriteInfo.areaLevel1Id && this.reWriteInfo.areaLevel2Id) {
                this.areas = [
                    this.reWriteInfo.areaLevel1Id,
                    this.reWriteInfo.areaLevel2Id
                ]
                this.form.area1 = this.reWriteInfo.areaLevel1Id;
                this.form.area2 = this.reWriteInfo.areaLevel2Id;

                if(this.reWriteInfo.clientAddress) {
                    this.form.address = this.reWriteInfo.clientAddress;
                }
            }

            if(this.reWriteInfo.clientMobile) {
                this.form.mobile = this.reWriteInfo.clientMobile;
            }

            if(this.reWriteInfo.doctorNo) {
                this.form.regCode = this.reWriteInfo.doctorNo;
            }

            if(this.reWriteInfo.clientMemberNo) {
                this.form.memberCode = this.reWriteInfo.clientMemberNo;
            }

            if(this.reWriteInfo.clientRegType) {
                this.form.regUserType = ""+this.reWriteInfo.clientRegType;
            }
        },
        // onChange(value) {
        //     if(!value || value.length === 0) {
        //         this.form.area1 = undefined
        //         this.form.area2 = undefined
        //         this.form.address = undefined
        //         return;
        //     }
        //     if(value.length == 2) {
        //         this.form.area1 = value[0]
        //         this.form.area2 = value[1]
        //     }
        // },
        // getAreaData: function(langcode, areaid, callback){
        //     this.$store.dispatch('getAreaList', {'langcode': langcode, 'parentId': areaid})
        //     .then((rs) => {
        //         callback && callback(rs, null)
        //     }).catch((rs) => {
        //         callback && callback(null, rs)
        //     })
        // },
        inited (viewer) {
            this.$viewer = viewer
        },
        inited2 (viewer2) {
            this.$viewer2 = viewer2
        },
        onContentClick: function(e) {
            if(e.target.src) {
                this.images = [e.target.src]
                setTimeout(() => {
                    this.$viewer.show()
                }, 500)
            }
           
        },
        onContentClick2: function(e) {
             if(e.target.src) {
                this.images2 = [e.target.src]
                setTimeout(() => {
                    this.$viewer2.show()
                }, 500)
            }
           
        },
        onPayModalClose: function(e) {
            this.payingVisible = false;
            this.$refs.ruleForm.resetFields();
            this.areas = [];
            this.form = {
                activityId: undefined, //活动id
                address: undefined, //个人地址
                area1: undefined, //地区编码1
                area2: undefined, //地区编码2
                currency: 'HK', //币种 CN人民币 / HK港币, 默认HK
                memberCode: undefined, //会员编号
                mobile: undefined, //联系电话
                paymentWay: undefined, //支付方式, 16微信 / 32支付宝
                regCode: undefined, //注册编号, 注册编号长度最大为10
                regUserName: undefined, //姓名
                regUserType: undefined, //参加者类别, 1医师 / 4非医师 / 2会员-医师 / 8会员-非医师
                remark: undefined, //备注
                source: 'WEB', // 请求数据来源, APP/WEB 默认WEB
                uid: this.$store.getters.userInfo && this.$store.getters.userInfo.clientid, //用户id
            };
            //支付结果确认窗口 关闭
            this.timer && clearInterval(this.timer);
            this.timer = null;
        },
        handleOk: function(e) {
            //报名活动信息确认操作
            var self = this;
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.$confirm({
                        title: '確認報名學會活動嗎?',
                        okText: "確認",
                        cancelText: "取消",
                        content(h) {
                            return <div style="color:red;">{self.showPay ? (self.form.paymentWay==32||self.form.paymentWay==16 ? '請在線完成付費操作' : '確認後，請等待學會審核') : '免費活動，確認後直接報名' }</div> 
                        },
                        onOk() {
                            self.confirmLoading = true
                            self.form.activityId = self.detail.activityid
                            self.$store.dispatch('joinActivity', self.form)
                            .then((rs)=>{
                                self.visible = false
                                self.confirmLoading = false
                                if(!rs.payUrl) {
                                    self.paySuccess = true
                                    self.payResultVisible = true
                                    self.payTitle = '加入學會活動成功'
                                    self.subPayTitle = ''
                                    return;
                                }
                                self.payUrl = rs.payUrl
                                self.$nextTick(()=>{
                                    document.querySelector("#payLink").click()
                                })
                            })
                            .catch((error)=>{
                                self.confirmLoading = false;
                                self.$message.warning(error || '操作失敗，請稍後重試')
                            })
                        },
                        onCancel() {
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        handleCancel: function(e) {
            //报名活动信息取消操作
            this.$refs.ruleForm.resetFields();
            this.areas = [];
            this.form = {
                activityId: undefined, //活动id
                address: undefined, //个人地址
                area1: undefined, //地区编码1
                area2: undefined, //地区编码2
                currency: 'HK', //币种 CN人民币 / HK港币, 默认HK
                memberCode: undefined, //会员编号
                mobile: undefined, //联系电话
                paymentWay: undefined, //支付方式, 16微信 / 32支付宝
                regCode: undefined, //注册编号, 注册编号长度最大为10
                regUserName: undefined, //姓名
                regUserType: undefined, //参加者类别, 1医师 / 4非医师 / 2会员-医师 / 8会员-非医师
                remark: undefined, //备注
                source: 'WEB', // 请求数据来源, APP/WEB 默认WEB
                uid: this.$store.getters.userInfo && this.$store.getters.userInfo.clientid, //用户id
            };
            this.visible = false;
        },
        // loadData(selectedOptions) {
        //     const targetOption = selectedOptions[selectedOptions.length - 1]
        //     targetOption.loading = true
        //     this.getAreaData('B5', targetOption.codeid, (rs, error)=>{
        //         targetOption.loading = false
        //         targetOption.children = rs || []
        //         this.options = [...this.options]
        //     })
        // },
    },
    watch: {
        '$route.params.id': function(id) {
            this.detail = JSON.parse(sessionStorage.getItem('detail'))
            if(this.detail) {
                this.setPayTypeList()
                this.changeNoticeTitle();
                this.jine = `學會會員: ${this.detail.entryfee2.toFixed(2)}HK$, 非學會會員: ${this.detail.entryfee.toFixed(2)}HK$`;
                var end = this.detail.endtime && new Date(this.detail.endtime.replace(/-/g, '/')).getTime()
                var now = Date.now()
                this.isFinished = false
                this.buttonText = '立即報名'
                if(this.detail.isRegActivity == true) {
                    this.buttonText = '已報名'
                } else if(now > end) {
                    this.isFinished = true
                    this.buttonText = '已結束'
                }
                if(this.detail.listattach && this.detail.listattach.length) {
                    var list = JSON.parse(JSON.stringify(this.detail.listattach))
                    this.imgFiles = list.map((d)=>{return {
                        "title": d['t'],
                        "path": (d['p'] || '').toLowerCase()
                    }}).filter((d)=>/(jpg|jpeg|png|bmp)$/.test(d.path)) || []

                    this.files = list.map((d)=>{return {
                        "title": d['t'],
                        "path": (d['p'] || '').toLowerCase(),
                        "fileType": (d['p'] || '').substr((d['p'] || '').lastIndexOf('.')+1),
                    }}).filter((d)=>!/(jpg|jpeg|png|bmp)$/.test(d.path)) || []
                }
            }
        },
        '$route.query.keyword': function(keyword) {
            this.detail = JSON.parse(sessionStorage.getItem('detail'))
            if(this.detail) {
                this.setPayTypeList()
                this.changeNoticeTitle();
                this.jine = `學會會員: ${this.detail.entryfee2.toFixed(2)}HK$, 非學會會員: ${this.detail.entryfee.toFixed(2)}HK$`;
                var end = this.detail.endtime && new Date(this.detail.endtime.replace(/-/g, '/')).getTime()
                var now = Date.now()
                this.isFinished = false
                this.buttonText = '立即報名'
                if(this.detail.isRegActivity == true) {
                    this.buttonText = '已報名'
                } else if(now > end) {
                    this.isFinished = true
                    this.buttonText = '已結束'
                }
                if(this.detail.listattach && this.detail.listattach.length) {
                    var list = JSON.parse(JSON.stringify(this.detail.listattach))
                    this.imgFiles = list.map((d)=>{return {
                        "title": d['t'],
                        "path": (d['p'] || '').toLowerCase()
                    }}).filter((d)=>/(jpg|jpeg|png|bmp)$/.test(d.path)) || []

                    this.files = list.map((d)=>{return {
                        "title": d['t'],
                        "path": (d['p'] || '').toLowerCase(),
                        "fileType": (d['p'] || '').substr((d['p'] || '').lastIndexOf('.')+1),
                    }}).filter((d)=>!/(jpg|jpeg|png|bmp)$/.test(d.path)) || []
                }
            }
        }
    }
}
</script>

<style lang="scss">
    .activity-detail {
        width: 100%;
        display: flex;
        flex-direction: column;
        position: relative;
        background-color: #fff;
        padding: 0px 24px;
    }

    .activity-detail.mask::before {
        content: '';
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 100;
        background-color: rgba(0, 0, 0, 0.5);
    }

    .activity-detail > .content {
        position: relative;
    }

    .activity-detail .pay-type {
        user-select: none;
        position: fixed;
        left: 50%;
        top: 50%;
        width: 50%;
        z-index: 101;
        transform: translate(-50%, -50%);
        height: 300px;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        padding: 24px;
        border-radius: 8px;
    }

    .activity-detail .pay-type .close {
        position: absolute;
        right: 12px;
        top: 12px;
        width: 32px;
        height: 32px;
        color: #666;
        cursor: pointer;
        user-select: none;
        z-index: 102;
        font-size: 22px;
        font-family: Arial, Helvetica, sans-serif;
        text-align: center;
        line-height: 32px;
    }

    .activity-detail .pay-type > .pay-type-head {
        color: #333;
        font-weight: bold;
        font-size: 32px;
        line-height: 44px;
    }

    .activity-detail .pay-type > .radio-group {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
    }

    .activity-detail .pay-type > .radio-group > .radio-item {
        margin-bottom: 24px;
    }

    .activity-detail .title {
        line-height: 30px;
        text-align: center;
        font-size: 28px;
        font-weight: bold;
        color: #1f1f1f;
        margin: 20px 0px;
    }

   .activity-detail .start-notice {
        margin-top: 10px;
        height: 32px;
        line-height: 32px;
        padding: 0 12px;
        font-weight: 400;
        text-align: left;
        color: #f00;
        font-size: 16px;
        border: 1px dashed #f00;
   }

    .activity-detail .create-time,
    .activity-detail .address,
    .activity-detail .sale {
        color: #232323;
        font-size: 16px;
        font-weight: 400;
        line-height: 18px;
        margin-top: 10px;
    }

    .activity-detail .create-time > .hint,
    .activity-detail .address > .hint,
    .activity-detail .sale > .hint {
        font-weight: bold;
    }

    .activity-detail .address > a {
        color: seagreen;
        text-decoration: underline;
        margin-left: 12px;
    }

    .activity-detail .intro {
        padding: 12px;
        color: #232323;
        font-size: 16px;
        font-weight: 400;
        background-color: #f7f7f9;
        border: 1px dashed #E1E1E8;
        margin-top: 10px;
    }
    
    .activity-detail .intro > .hint {
        font-weight: bold;
    }

    .activity-detail .content-wrapper {
        display: flex;
        flex-direction: column;
        margin: 12px 0;
    }

    .activity-detail .content-wrapper img {
        margin: 4px 0px;
        width: 100%;
        object-fit: contain;
    }

    .activity-detail .content-wrapper p {
        color: #232323;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
    }

    .activity-detail .btn-wrapper {
        width: 100%;
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .viewer-info {
        display: flex;
        flex-direction: column;
        margin-bottom: 10px;
    }
    
    .viewer-info > .act-title,
    .viewer-info > .act-time,
    .viewer-info > .act-address {
        color: #666;
        font-size: 16px;
        margin-top: 10px;
        border-radius: 4px;
        padding: 2px 8px;
        position: relative;
        z-index: 1;
    }
    
    .viewer-info > .act-title > .hint,
    .viewer-info > .act-time > .hint,
    .viewer-info > .act-address > .hint {
        color: #1c1c1c;
        font-weight: 400;
        font-size: 16px;
    }

    @media only screen and (max-width: 1050px) {
        .ant-modal-body {
            padding: 12px;
        }
        .ant-row.ant-form-item {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
        }

        .ant-row.ant-form-item .ant-col.ant-form-item-control-wrapper {
            width: unset;
            flex: 1;
        }

        .ant-row.ant-form-item .ant-form-item-label {
            width: 24%;
        }

        .activity-detail .pay-type {
            position: fixed;
            left: 50%;
            top: 50%;
            width: 90%;
            z-index: 101;
            transform: translate(-50%, -50%);
            height: 300px;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            padding: 24px;
            border-radius: 8px;
        }
    }

    .icon-pay {
        width: 36px;
        height: 36px;
        margin-right: 12px;
        margin-left: 6px;
        object-fit: fill;
        vertical-align: bottom;
    }
    .txt-pay {
        font-size: 24px;
        font-weight: bold;
        margin-right: 10px;
    }

    /* 支付方式选中加边框 start */
    .radio-item.ant-radio-wrapper {
        margin-left: 4px;
    }

    .radio-item.ant-radio-wrapper-checked {
        position: relative;
    }

    .radio-item.ant-radio-wrapper-checked::after {
        position: absolute;
        left: -6px;
        right: -6px;
        top: -6px;
        bottom: -8px;
        content: '';
        border: 2px solid #1890ff;
        box-shadow: 1px 1px 2px #ccc;
        border-radius: 4px;
    }
    /* 支付方式选中加边框 end */

    .pay-list {
        display: flex;
        flex-wrap: wrap;
    }

    .pay-list > .radio-item {
        display: inline-block;
        margin-bottom: 12px;
    }

    .link-activity {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        margin-top: -25px;
        line-height: 30px;
    }
    .link-activity > a {
        color: seagreen;
        text-decoration: underline;
    }
</style>
